import { render, staticRenderFns } from "./MechanicsDetail.vue?vue&type=template&id=7c4465de&scoped=true"
import script from "./MechanicsDetail.vue?vue&type=script&lang=ts"
export * from "./MechanicsDetail.vue?vue&type=script&lang=ts"
import style0 from "./MechanicsDetail.vue?vue&type=style&index=0&id=7c4465de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4465de",
  null
  
)

export default component.exports